export default {
  okText: 'OK',
  closeText: 'Close',
  cancelText: 'Cancel',
  loadingText: 'Loading...',
  saveText: 'Save',
  delText: 'Delete',
  resetText: 'Reset',
  searchText: 'Search',
  queryText: 'Search',
  inputText: 'Please enter',
  chooseText: 'Please choose',
  redo: 'Refresh',
  back: 'Back',
  light: 'Light',
  dark: 'Dark',
  edit: "Edit",
  fullScreen: "fullScreen",
  exitfullScreen: "exitfullScreen",
  LockScreen: "LockScreen",
  ExitSystem: "ExitSystem",
  changeLuaguage: "changeLuaguage",
  Loading: "Loading,please wait...",
  SaveSuccess: "Save success",
  DelSuccess: "Delete  success"
};
